import { Typography, Grid, withStyles, Theme } from '@material-ui/core'
import { ReactNode } from 'react'
import suggestIcon from '../../../images/suggest.svg'
import { MuiClasses } from '../../../types'

type SuggestProps = {
  classes: MuiClasses
  content?: string
  isModal?: boolean
  hideSuggestIcon?: boolean
  customSuggestTextStyles?: string
  containerStyle?: string
  suggestContainerStyle?: string
  renderText?: () => ReactNode
  handleClick?: () => void
  clickable?: boolean
}
const styles = ({ breakpoints }: Theme) => ({
  largeForm: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    justifySelf: 'center',
    [breakpoints.down('sm')]: {
      padding: '10px 0'
    },
    [breakpoints.up('lg')]: {
      display: 'flex'
    }
  },
  suggestContainer: {
    background: '#FBF6EE',
    padding: '25px 40px',
    display: 'flex',
    justifyContent: 'center',
    fontSize: '12px',
    borderRadius: '25px',
    [breakpoints.up('xs')]: {
      padding: '25px'
    },
    '& img': {
      marginRight: '10px',
      marginBottom: '10px'
    }
  },
  stepTwoInfo: {
    display: 'flex',
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center'
    }
  },
  suggestIcon: {
    float: 'left' as const,
    padding: '5px'
  },
  suggestText: {
    textAlign: 'left' as const,
    fontSize: '2rem',
    [breakpoints.up('md')]: {
      overflow: 'hidden'
    }
    // [breakpoints.down('sm')]: {

    // }
  },
  w13: {
    width: '13%'
  },
  w80: {
    width: '100%',
    [breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  wfull: {
    width: '100%'
  },
  cursorPointer: {
    cursor: 'pointer'
  }
})

const Suggest = ({
  classes,
  content,
  isModal,
  hideSuggestIcon,
  customSuggestTextStyles,
  suggestContainerStyle,
  containerStyle,
  renderText,
  handleClick,
  clickable
}: SuggestProps) => {
  return (
    <div className={`${classes.largeForm} ${containerStyle}`}>
      <Grid
        container
        onClick={handleClick}
        className={`${classes.suggestContainer} ${suggestContainerStyle} ${
          clickable ? classes.cursorPointer : ''
        }`}
        style={{ flexWrap: 'nowrap' }}
      >
        {!isModal && (
          <Grid item>
            <img src={suggestIcon} />
          </Grid>
        )}
        {/* <Grid container> */}
        <div className={classes.stepTwoInfo}>
          {isModal && !hideSuggestIcon && (
            <Grid item className={classes.w13}>
              <img
                src={suggestIcon}
                className={classes.suggestIcon}
                alt={'Suggest Icon'}
              />
            </Grid>
          )}
          <Grid item className={hideSuggestIcon ? classes.wfull : classes.w80}>
            {renderText ? (
              renderText()
            ) : (
              <Typography
                // variant='body2'
                className={`${classes.suggestText} ${customSuggestTextStyles}`}
                style={{
                  whiteSpace: 'pre-line',
                  textAlign: 'center'
                }}
              >
                {content || `Kindly populate with content`}
              </Typography>
            )}
          </Grid>
        </div>
        {/* </Grid> */}
      </Grid>
    </div>
  )
}
export default withStyles(styles)(Suggest)
